// Import Turbo and expose it globally for code expecting window.Turbo

import '@hotwired/turbo-rails'

// Sentry error tracking
import * as Sentry from "@sentry/browser"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.eventFiltersIntegration({
      ignoreErrors: [
        /AbortError/,
        /Failed to fetch/,
        /NetworkError/,
        /Load failed/,
      ],
      denyUrls: [
        /extensions\//i,
        /^chrome:\/\//i,
        /^moz-extension:\/\//i,
      ],
    }),
  ],
  tracesSampleRate: 0.0, // Disabled to stay within free tier
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
})

// Import SortableJS and expose as global for controllers using window.Sortable
import Sortable from "sortablejs"
window.Sortable = Sortable

// Import Stimulus controllers
import "../controllers"

// Import ActionCable channels
import "../channels"

// Import modal confirm hook
import "../lib/modal_confirm"

// Close open Tailwind-styled <details data-taildrop> when clicking outside
document.addEventListener('click', (e) => {
  document.querySelectorAll('details[data-taildrop][open]').forEach((el) => {
    if (!el.contains(e.target)) el.removeAttribute('open')
  })
})

// Utility listeners from the old Importmap application.js
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState !== "visible") return

  document.querySelectorAll("turbo-frame[src]").forEach(frame => {
    // reassigning src makes Turbo refetch just that frame
    frame.src = frame.src
  })
})

document.addEventListener('animationend', function(e) {
  if (e.target.classList.contains('damage-floater')) {
    e.target.remove()
  }

  // Remove the chain zap *class* from tiles after the flicker ends
  if (e.animationName === 'chain-flicker') {
    e.target.classList.remove('chain-zap');
  }
})

document.addEventListener("turbo:submit-end", (event) => {
  const form = event.target
  if (!(form instanceof HTMLFormElement)) return
  if (!event.detail || event.detail.success !== true) return

  const action = form.getAttribute("action") || ""
  let pathname = action
  try {
    pathname = new URL(action, window.location.origin).pathname
  } catch (error) {
    // Ignore parsing issues for relative actions
  }

  if (pathname === "/logout") {
    try {
      window.localStorage.clear()
    } catch (error) {
      // Ignore storage clearing issues (e.g., storage disabled)
    }
  }
})
